<div class="switch-container" [style.width]="width">
  <button class="button round-left" [ngClass]="{ smalltoggle: small, checked: !value, red: !small }" (click)="onClick(false)">{{ option1 }}</button>
  <button class="button round-right" [ngClass]="{ smalltoggle: small, checked: value, green: !small }" (click)="onClick(true)">{{ option2 }}</button>
</div>
